import { gql } from '@apollo/client';
import Participant from 'models/participant';
import { SEASON_PARTICIPANT_FIELDS } from '../fragments/season-participant';

export interface Data {
  members: Array<Participant>;
}

const SEASON_PARTICIPANT_MEMBER_INFO = `
  id
  firstName
  lastName
  birthdate
  gender
  organizationId
  insertedAt
  joinedAt
  emailAddresses {
    id
    email
  }
  addresses {
    id
    line1
    line2
    city
    state
    postalCode
  }
  phoneNumbers {
    id
    number
  }
  seasonParticipants(filter: { isArchived: null, seasonId: $seasonId }) {
    ${SEASON_PARTICIPANT_FIELDS}
  }
`;
export const SHOW_ALL_SEASON_PARTICIPANTS = gql`
  query Members($seasonId: ID!, $pageSize: Int, $pageNumber: Int, $searchTerm: String) {
    members(filter: { seasonId: $seasonId, pageSize: $pageSize, pageNumber: $pageNumber, searchTerm: $searchTerm }) {
      __typename
      data {
       ${SEASON_PARTICIPANT_MEMBER_INFO}
      }
    }
  }
`;

export const SHOW_SEASON_PARTICIPANT = gql`
  query Member($organizationId: Int!, $seasonId: ID!, $memberId: Int!) {
    member(organizationId: $organizationId, memberId: $memberId, seasonId: $seasonId ) {
      __typename
      ${SEASON_PARTICIPANT_MEMBER_INFO}
    }
  }
`;
